import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import {
  ACTIONS_TASK,
  ACTIONS_TEXT,
  ACTION_TASK_CONSTANTS
} from "../../constants/ActionConstants";
import Vuetify from "vuetify";
import { ActionId } from "../../models/ActionId";
import { ActionTask, ActionTaskError } from "../../models/ActionTask";
import { Http } from "@status/codes";
import { DashboardService } from "../../services/DashboardService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import TabsError from "./components/TabsError/TabsError.vue";
import UpdateTask from "./components/UpdateTask/UpdateTask.vue";
import ReasingTask from "./components/ReasingTask/ReasingTask.vue";
import AsingTaskDependency from "./components/AsingTaskDependency/AsingTaskDependency.vue";

Vue.use(Vuetify);

@Component({
  name: "TaskActions",
  components: {
    UpdateTask,
    ReasingTask,
    AsingTaskDependency,
    TabsError
  }
})
export default class TaskActions extends Vue {
  @Prop() openModal!: boolean;
  @Prop() actionTask!: string;
  @Prop() userIdArray!: ActionId[];

  @Inject() dashboardService!: DashboardService;

  LABELS = ACTION_TASK_CONSTANTS.LABELS;

  cardClass = STYLE_CLASSES.CARD;
  btnClassPrimary = STYLE_CLASSES.PRIMARY_BTN;
  btnClassSecondary = STYLE_CLASSES.SECONDARY_BTN;
  actionText = ACTIONS_TEXT;
  actionEvents = ACTIONS_TASK;

  canSendAction = false;
  state = "";
  usersId: string[] = [];
  dependency = "";
  errors: ActionTaskError[] = [];
  success: ActionTaskError[] = [];
  loading = false;

  closeModal() {
    this.usersId = [];
    this.disabledAccepButton();
    let search = true;
    if (
      (this.errors.length > 0 && this.success.length == 0) ||
      (this.errors.length == 0 && this.success.length == 0)
    )
      search = false;

    this.$emit(ACTION_TASK_CONSTANTS.EMMITS.CLOSE_TASK_ACTIONS_MODAL, search);
    this.errors = [];
    this.success = [];
  }

  async applyAction() {
    try {
      this.loading = true;
      await this.executeAction();
      this.loading = false;
    } catch (error) {
      this.loading = false;
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async executeAction() {
    const action: ActionTask = {
      type: this.actionTask
    };

    if (this.actionTask == this.actionEvents.UPDATE_TASK_STATE) {
      action.state = this.state;
      action.tasksIds = this.userIdArray.map(item => item.ref as string);
    } else if (this.actionTask == this.actionEvents.REASING_TASKS) {
      action.usersId = this.usersId;
      action.tasksIds = this.userIdArray.map(item => item.ref as string);
    } else {
      action.dependency = this.dependency;
      action.formTemplatesId = [
        ...new Set(this.userIdArray.map(item => item.formTemplateId))
      ] as string[];
    }
    const response = await this.dashboardService.applyTaskActions(action);

    if (response.code == Http.PartialContent && response.data) {
      this.errors = response.data.errors;
      this.success = response.data.success;
      Snackbar.popSuccess(response.message);
    } else if (response.code == Http.Ok && response.data) {
      this.success = response.data.success;
      Snackbar.popSuccess(response.message);
    } else if (response.code == Http.Conflict && response.data) {
      this.errors = response.data.errors;
      Snackbar.popError(response.message);
    }

    this.state = "";
    this.dependency = "";
    this.usersId = [];
  }

  showAcceptButton() {
    return this.errors.length == 0 && this.success.length == 0;
  }

  disabledAccepButton() {
    if (this.usersId.length > 0) {
      this.canSendAction = true;
    }

    return (
      !this.canSendAction ||
      this.loading ||
      (this.usersId.length == 0 &&
        this.actionTask == this.actionEvents.REASING_TASKS)
    );
  }

  addResponsible(responsibles: string[]) {
    this.usersId = [...responsibles];
    this.disabledAccepButton();
  }
}
